/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable array-callback-return */
import React, { useEffect, useState, useRef } from "react";
import { useTranslation } from "react-i18next";
import GridContainer from "./GridContainer";
import { useSelector, useDispatch } from "react-redux";
import Loader from "../../shared/Loader/Loader";
import * as documentActions from "../../../../store/actions/documentActions";
import * as zoneActions from "../../../../store/actions/zoneActions";
import DeleteDocumentPopUp from "../../shared/DeleteDocumentPopUp/DeleteDocumentPopUp";
import DocumentViewModal from "../ZonesSections/DocumentViewModal";
import * as fileUploadActions from "../../../../store/actions/fileUploadActions";
import * as UtilsHelper from "../../../../../utils/utilsHelper";
import APP_CONST from "../../../shared/constants";
import _ from "underscore";
import FilterInformation from "./FilterInformation";
import PlaceholderComponent from "../../../containers/ArchiveDashboard/PlaceholderComponent";
import useDetectClickOutside from "../../../../../hooks/useDetectClickOutside";

const DocumentsSection = () => {
  const { t } = useTranslation();
  const dispatch = useDispatch();

  const {
    apiInitConfigObj,
    zoneItems,
    countrySiteList,
    metricsData,
    recordState,
    isManageDropZoneAvailable,
    isRoleListLoaded,
    isOverViewLoading,
  } = useSelector((store) => store.zone);
  const { sharedfilecount, privatefilecount, lockStatus, isLockLoading } =
    useSelector((store) => store.template);

  const {
    AgGridDocument: { documentdetails },
    isLoading,
    customizedColState,
    customizedFilterState,
  } = useSelector((store) => store.document);

  let filterRef = useRef();

  useDetectClickOutside(filterRef, () => {
    closeMenu(false);
  });
  const gridContainerRef = useRef();

  const setGridContainerRef = (gridRef) => {
    gridContainerRef.current = gridRef.current;
  };

  const [fromTo, setFromTo] = useState("Documents");
  const [docDetails, setDocDetails] = useState();
  const [viewDocumentObj, setViewDocumentObj] = useState(false);
  const [showDocDeletePopup, setShowDocDeletePopup] = useState(false);
  const [docDeleteData, setDocDeleteData] = useState({});
  const [sectionOrigid, setSectionOrigid] = useState("");
  const [getorigiartifactid, setorigiartifactid] = useState("");
  const [downloadingDocId, setDownloadingDocId] = useState("");
  const [isDocViewVisible, setIsDocViewVisible] = useState(false);
  const [allArtifactList, setAllArtifactList] = useState({});
  const [selectedArtifactDetails, setSelectedArtifactDetails] = useState({});
  const [selectedDocumentId, setSelectedDocumentId] = useState("");
  const [permissionsObject, setPermissionsObject] = useState({});
  const [isGridReset, setIsGridReset] = useState(false);
  const [agFilterValue, setAgFilterValue] = useState(false);
  const [filterBadge, setFilterBadge] = useState(null);
  const [searchKey, setSearchKey] = useState("");
  const totalDocuments =
    metricsData.totalDocWithUnpubCount + sharedfilecount + privatefilecount;

  const [openMenu, closeMenu] = useState(false);
  const [selectedValue, setSelectedValue] = useState("");
  const [tempCustomizedColState, setTempCustomizedColState] = useState(
    sessionStorage.getItem("tempCustomizedColState")
  );
  const [tempCustomizedFilterState, setTempCustomizedFilterState] = useState(
    sessionStorage.getItem("tempCustomizedFilterState")
  );
  const [tempDefaultColState, setTempDefaultColState] = useState(
    sessionStorage.getItem("tempDefaultColState")
  );
  const [tempDefaultFilterState, setTempDefaultFilterState] = useState(
    sessionStorage.getItem("tempDefaultFilterState")
  );
  const [extraFilters, setExtraFilters] = useState([]);
  const [currentMode, setCurrentMode] = useState("");
  const [fileCount, setFileCount] = useState(0);
  const [isFilterHappend, setIsFilterHappend] = useState(false);
  const [agGridListCount, setAgGridListCount] = useState(0);
  const [dropdownChange, setDropDownChanged] = useState(false);
  const [dropdownChangeFilter, setDropDownChangedFilter] = useState(false);
  const [tmpfileGuid, setTmpFileGuid] = useState(null);
  const [tmpSingleFileDetail, setTmpSingleFileDetail] = useState(null);
  const [isDocNewVersionCreated, setIsDocNewVersionCreated] = useState(false);
  const [isBadgeRemoved, setIsBadgeRemoved] = useState(false); // Added this state in order to enable save as customize action, once user remove the filter badge with close icon in it.
  // eslint-disable-next-line no-unused-vars
  const [dropDownVisibilty, setDropDownVisibilty] = useState({
    default: currentMode === "Default",
    customize:
      (customizedColState === "{}" || customizedColState === "undefined") &&
      (customizedFilterState === "{}" || customizedFilterState === "undefined"),
    reset: false,
    save: false,
  });
  let isCustomizedChanged =
    !!tempCustomizedColState || !!tempCustomizedFilterState;
  let isDefaultChanged = !!tempDefaultColState || !!tempDefaultFilterState;
  const payload = {
    searchKey: searchKey,
    site: "ALL",
    countryCode: "ALL",
    pageCount: 0,
    pageSize: 20000,
    pageNumber: 1,
    artifactId: "",
    sectionid: "",
    category: "",
    milestoneGroup: "ALL",
    milestoneId: "",
    lastdocumentupdatedon: "",
  };
  let lastdocumentupdatedon = sessionStorage.getItem("lastdocumentupdatedon");
  let recentSearchInfo = {
    searchKey: "",
    site: "ALL",
    countryCode: "ALL",
    pageCount: 0,
    pageSize: 20000,
    pageNumber: 1,
    artifactId: "",
    sectionid: "",
    category: "",
    milestoneGroup: "ALL",
    milestoneId: "",
    lastdocumentupdatedon:
      lastdocumentupdatedon !== null ? lastdocumentupdatedon : "",
  };
  let recentSearched = JSON.parse(sessionStorage.getItem("recent_search_info"));
  recentSearched === null &&
    sessionStorage.setItem(
      "recent_search_info",
      JSON.stringify(recentSearchInfo)
    );
  let actionColumns = [
    {
      value: "Default",
      label: t("TMF.TEXT_DEFAULT"),
      disabled: dropDownVisibilty.default || currentMode === "Default" || recordState !== "/records",
    },
    {
      value: "Customized",
      label: t("TMF.TEXT_CUSTOMISED"),
      disabled:
        ((sessionStorage.getItem("customizedColState") === "{}" ||
          customizedColState === "undefined") &&
          (sessionStorage.getItem("customizedFilterState") === "{}" ||
            customizedFilterState === "undefined")) ||
        currentMode === "Customized" || recordState !== "/records",
    },
    {
      value: "Reset Columns",
      label: t("TMF.TEXT_RESETCOLUMNS"),
      disabled: !isCustomizedChanged && !isDefaultChanged && !isBadgeRemoved,
    },
    {
      value: "Save as customized",
      label: t("TMF.TEXT_SAVEASCUSTOM"),
      disabled: false,
    },
  ];

  useEffect(() => {
    if (apiInitConfigObj?.aggridaccess) {
      dispatch(documentActions.getCustomizedColumState());
      dispatch({ type: "AGGRID_GET_CALL", payload: payload });
    }
    setFilterBadge(null);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [apiInitConfigObj]);

  useEffect(() => {
    if (_.isEmpty(documentdetails)) return;
    const selectedDoc = documentdetails.find(
      (doc) => doc.documentid === selectedDocumentId
    );
    setDocDetails({ ...selectedDoc, ...permissionsObject });
  }, [documentdetails]);

  useEffect(() => {
    const sectionsItems = _.flatten(_.pluck(zoneItems, "sections"));
    const artiFactItems = _.flatten(_.pluck(sectionsItems, "artifacts"));
    setAllArtifactList(artiFactItems);
  }, [zoneItems]);

  const captureAppliedFilter = () => {
    if (
      gridContainerRef.current === null ||
      gridContainerRef.current === undefined
    )
      return;
    const filterModel = gridContainerRef.current.api.getFilterModel();
    if (_.isEmpty(filterModel)){ 
      setExtraFilters([]);
      return; 
    }
    let newFilter = Object.keys(filterModel);
    const index = newFilter.indexOf("status");
    if (index > -1) {
      newFilter.splice(index, 1);
    }
    setExtraFilters(newFilter);
  };

  const removeExtraFilter = (filterName) => {
    extraFilters.splice(extraFilters.indexOf(filterName), 1);
    gridContainerRef.current.api.destroyFilter(filterName);
    setIsBadgeRemoved(true);
  };

  const findArtifactSettings = (id) => {
    const returnObj = _.find(allArtifactList, { origid: id });
    return returnObj;
  };

  const searchDocument = (from = false) => {
    sessionStorage.setItem(
      "recent_search_info",
      JSON.stringify({ ...payload, searchKey: from ? "" : searchKey })
    );
    dispatch({
      type: "AGGRID_GET_CALL",
      payload: { ...payload, searchKey: from ? "" : searchKey },
    });
  };

  useEffect(() => {
    sessionStorage.removeItem("tempCustomizedColState");
    sessionStorage.removeItem("tempCustomizedFilterState");
    sessionStorage.removeItem("tempDefaultColState");
    sessionStorage.removeItem("tempDefaultFilterState");
    setTempCustomizedColState(sessionStorage.getItem("tempCustomizedColState"));
    setTempCustomizedFilterState(
      sessionStorage.getItem("tempCustomizedFilterState")
    );
    setTempDefaultColState(sessionStorage.getItem("tempDefaultColState"));
    setTempDefaultFilterState(sessionStorage.getItem("tempDefaultFilterState"));
    document.addEventListener("dialog-hide", (e) => {
      setViewDocumentObj(false);
      setShowDocDeletePopup(false);
    });
  }, []);

  const documentDetailsHandler = async (documentDetails) => {
    if (documentDetails && !documentDetails.tmfdropzoneid) {
      const foundObj = findArtifactSettings(documentDetails.origiartifactid);
      let docDetailData = {
        docDetail: documentDetails,
        artifactDetail: foundObj,
      };
      const getDocData = documentdetails.filter(
        (item) => item.docid === docDetailData.docDetail.docid
      );
      docDetailData = {
        ...docDetailData,
        docDetail: {
          ...docDetailData.docDetail,
          datingconventiondate: getDocData[0].datingconventiondate,
        },
      };
      const reqObject = {
        artifactuseraccess: foundObj.artifactuseraccess,
        rolePermission: foundObj.rolePermission,
        documenttmflevel: documentDetails.documenttmflevel,
        sitesid: documentDetails.sitesid,
        countriesid: documentDetails.countriesid,
        countrySiteList,
      };
      let isArtifactDeleted = documentDetails.isdeleted;
      const permissionObject = UtilsHelper.permissionObject(reqObject);
      setPermissionsObject(permissionObject);
      docDetailData = {
        ...docDetailData,
        ...permissionObject,
        docDetail: {
          ...docDetailData.docDetail,
          ...permissionObject,
        },
        isArtifactDeleted,
      };

      if (foundObj.origid === "00.00.00") {
        docDetailData = {
          ...docDetailData,
          writePermission: true,
        };
      }
      setSelectedArtifactDetails({
        ...selectedArtifactDetails,
        ...docDetailData.artifactDetail,
      });
      setDocDetails(docDetailData.docDetail);
    } else {
      setDocDetails(documentDetails);
    }
    setViewDocumentObj(true);
    const {
      documentid,
      documentguid,
      lastmodifiedon,
      documentversionguid,
      docid,
      createdon,
      tmfdropzoneid,
      trialmasterfilesharingsettings,
    } = documentDetails;
    setSelectedDocumentId(documentid);
    const lastModifiedOn = lastmodifiedon ? lastmodifiedon : createdon;
    let payloadData = { documentid, lastModifiedOn, documentversionguid };
    if (tmfdropzoneid) {
      payloadData = {
        ...payloadData,
        documentid: documentguid,
      };
    }

    dispatch(
      documentActions.getDocNote(
        documentversionguid,
        tmfdropzoneid ? tmfdropzoneid : APP_CONST.HARD_CODED.dummyId
      )
    );

    !["Unpublished", "Finalized"].includes(documentDetails?.status) &&
      !documentDetails.tmfdropzoneid &&
      dispatch(
        documentActions.documentGetReview({ documentid, documentversionguid })
      );

    dispatch(documentActions.getDocumentHistory(payloadData));

    !["Unpublished"].includes(documentDetails?.status) &&
      dispatch(documentActions.doGetDocumentVersionList(docid));

    dispatch(documentActions.getAdminSharingSettings());
    !["Unpublished"].includes(documentDetails?.status) &&
      !documentDetails.tmfdropzoneid &&
      dispatch(documentActions.getDocSharingMetricsByVersionId(documentid));
    const reqPayload = {
      documentid: documentid,
      isForceDataGet: true,
      lastModifiedOn: null,
    };
    !documentDetails.tmfdropzoneid &&
      dispatch(documentActions.getExistingSharedUsersList(reqPayload));

    !documentDetails.tmfdropzoneid &&
      dispatch(
        documentActions.getDocSharingUserList({
          documentid,
          isrequiredclinic: true,
          isrequiredsubject:
            trialmasterfilesharingsettings?.isenabledforsubjectusers || false,
        })
      );
  };

  const onDownloadIconClick = (data, isDialog, status) => {
    if (status) {
      setViewDocumentObj(false);
    }
    setDownloadingDocId(data.docid);
    let downTemplate = "";
    const origfilename = data?.tmfdropzoneid
      ? data?.filename.split(
          `.${UtilsHelper.getFileExtension(data?.filename)}`
        )[0]
      : data?.downloadtemplate
      ? data?.downloadtemplate
      : data.origfilename.split(`.${data.type}`)[0];
      let downloadFileName = "";
      if(!(isDocNewVersionCreated && tmpfileGuid)){
        downloadFileName = downTemplate && downTemplate !== ""
        ? downTemplate
        : data.title === "customName"
        ? data.customTitle
        : APP_CONST.TITLE_ARRAY.includes(data.title)
        ? data.documenttypevalue || data.artifact
        : origfilename;
      } else {
        downloadFileName = !_.isEmpty(tmpSingleFileDetail) ? tmpSingleFileDetail[0].name : origfilename
      }
    const displayOrder = UtilsHelper.constructDisplayOrder(data.status);
    const fileProps = {
      ...data,
      downloadFileName,
      displayOrder: displayOrder,
    };
    data.tmfdropzoneid || data.category
      ? dispatch(
          fileUploadActions.fileDownloadUrl(
            UtilsHelper.prepareDownloadRequestPayload(fileProps),
            isDialog,
            data.category
          )
        )
      : dispatch(
          fileUploadActions.fileDownloadUrl(
            UtilsHelper.prepareDownloadRequestPayload(fileProps),
            isDialog,
            "",
            fileProps,
            isDocNewVersionCreated && tmpfileGuid ? tmpfileGuid : "",
            isDocNewVersionCreated && tmpfileGuid ? tmpSingleFileDetail[0].name : "",
          )
        );
  };

  const showFilterOptions = () => {
    return (
      <div className="awiting-option" onClick={() => closeMenu(!openMenu)}>
        <span>...</span>
      </div>
    );
  };
  const onDropDownValuesChange = (e) => {
    if (!e.target.disabled) {
      if (e.target.value === "Save as customized") {
        if (isCustomizedChanged || isDefaultChanged || isBadgeRemoved) {
          setIsGridReset(false);
          setSelectedValue(e.target.value);
          if (e.target.value === "Default" || e.target.value === "Customized") {
            setCurrentMode(e.target.value);
          }
          setDropDownChanged(true);
          setDropDownChangedFilter(true);
          closeMenu(false);
        }
      } else {
        setIsGridReset(false);
        setSelectedValue(e.target.value);
        if (e.target.value === "Default" || e.target.value === "Customized") {
          setCurrentMode(e.target.value);
        }
        setDropDownChanged(true);
        setDropDownChangedFilter(true);
        closeMenu(false);
      }
    }
  };
  const renderDropdown = (mappingvalues) => {
    return (
      <div className="customize-details" ref={filterRef}>
        <viedoc-menu
          onClick={(e) => {
            onDropDownValuesChange(e);
          }}
        >
          {mappingvalues.map((item) => (
            <viedoc-menu-item
              key={item.value}
              size="medium"
              value={item.value}
              disabled={item.disabled ? true : null}
            >
              {item.label}
            </viedoc-menu-item>
          ))}
        </viedoc-menu>
      </div>
    );
  };

  const filterDocumentHandler = (e) => {
    setSearchKey(e.target.value);
    if (!e.target.value) {
      searchDocument(true);
    }
  };

  const renderCountValue = () => {
    if (!_.isEmpty(searchKey)) {
      return `${t("TMF.TEXT_FOUND").toLocaleLowerCase()} ${agGridListCount}`;
    }
    if (totalDocuments === agGridListCount) return totalDocuments;
    if (
      recordState === "/records" &&
      currentMode === "Default" &&
      !_.isEmpty(extraFilters)
    ) {
      return `${agGridListCount} of ${totalDocuments}`;
    } else if (recordState === "/records" && currentMode === "Default") {
      return totalDocuments;
    }
    return `${agGridListCount} of ${totalDocuments}`;
  };

  const renderHeaderComponent = () => {
    return (
      <div className="zone-section-content pl-30 pr-30 d-flex">
        <h3>
          {`${t("OVERVIEW.TEXT_RECORDS")} `}
          {!isLoading &&
            _.isEmpty(agGridListCount) &&
            (isOverViewLoading ? (
              <span className="count-spinner">
                <viedoc-spinner />
              </span>
            ) : (
              <span>({renderCountValue()})</span>
            ))}
        </h3>
        <div className="zone-filter-panel">
          <div className="d-flex">
            <viedoc-textfield prefix-icon="search">
              <input
                type="text"
                placeholder={t("DETAILPAGE.LABEL_SEARCH")}
                value={searchKey}
                onChange={(e) => {
                  filterDocumentHandler(e);
                }}
                onKeyPress={(e) => {
                  if (e.which === 13) {
                    searchDocument();
                  }
                }}
              />
            </viedoc-textfield>
            {(recordState === "/records" || _.isEmpty(recordState)) && (
              <label className="records-filter-label">{`${
                currentMode === "Customized"
                  ? t("TMF.TEXT_CUSTOMISED")
                  : t("TMF.TEXT_DEFAULT")
              } ${isCustomizedChanged || isDefaultChanged || isBadgeRemoved ? "+" : ""}`}</label>
            )}
            {showFilterOptions()}
            {openMenu && renderDropdown(actionColumns)}
          </div>
        </div>
      </div>
    );
  };

  const deletePopup = (data) => {
    setShowDocDeletePopup(true);
    setSectionOrigid(data.sectionid);
    setorigiartifactid(data.origiartifactid);
    if (data.category) {
      setFromTo("Dropzone");
      setDocDeleteData({
        id: data.tmfdropzoneid,
        category: data.category,
        fileName: data.filename,
        subType: "DocDropZone",
      });
    } else {
      setFromTo("Documents");
      setDocDeleteData({
        id: data.documentid,
        lastModifiedOn: data.lastmodifiedon || data.createdon,
        fileName: data.origfilename,
      });
    }
  };

  const getAgResultCount = (countValue) => {
    setAgGridListCount(countValue);
  };

  const onRemove = () => {
    setExtraFilters([]);
    gridContainerRef.current.api.setFilterModel(null);
    setFilterBadge(null);
    dispatch(zoneActions.getRecordState("/records"));
    // onDropDownValuesChange({
    //   target: { value: "Customized", disabled: false },
    // });
  };

  return (
    <>
      {isLockLoading || !isRoleListLoaded ? (
        <Loader />
      ) : !isManageDropZoneAvailable &&
        lockStatus !== APP_CONST.ADMIN_TEMPLATE_STATUS[1] ? (
        <PlaceholderComponent title={t("TMF.TEXT_STUDYNOTINSTANTIATED")} />
      ) : (
        <div className={"Document_Section document-page-record"}>
          {renderHeaderComponent()}

          {(!_.isEmpty(filterBadge) || !_.isEmpty(extraFilters)) &&
            !isLoading && (
              <FilterInformation
                filterBadge={filterBadge}
                onRemove={onRemove}
                extraFilters={extraFilters}
                removeExtraFilter={removeExtraFilter}
              />
            )}
          {viewDocumentObj && (
            <DocumentViewModal
              onDownloadIconClick={onDownloadIconClick}
              docDetails={docDetails}
              setViewDocumentObj={setViewDocumentObj}
              isDocViewVisible={isDocViewVisible}
              setIsDocViewVisible={setIsDocViewVisible}
              selectedArtifactDetails={selectedArtifactDetails}
              from="Documents"
              documentPermission={
                selectedArtifactDetails &&
                selectedArtifactDetails.origid !== "00.00.00"
                  ? selectedArtifactDetails.rolePermission || ""
                  : "WRITE"
              }
              downloadingDocId={downloadingDocId}
              setDownloadingDocId={setDownloadingDocId}
              setTmpFileGuid={setTmpFileGuid}
              setTmpSingleFileDetail={setTmpSingleFileDetail}
              setIsDocNewVersionCreated={setIsDocNewVersionCreated}
            />
          )}
          {showDocDeletePopup && (
            <DeleteDocumentPopUp
              deletePayload={docDeleteData}
              setShowDocDeletePopup={setShowDocDeletePopup}
              sectionOrigid={sectionOrigid}
              origiartifactid={getorigiartifactid}
              fromTo={fromTo}
            />
          )}
          {isLoading ? (
            <Loader height={"60%"} />
          ) : (
            <>
              <GridContainer
                rowList={documentdetails}
                documentDetailsHandler={documentDetailsHandler}
                onDownloadIconClick={onDownloadIconClick}
                deletePopup={deletePopup}
                downloadingDocId={downloadingDocId}
                dropdownChange={dropdownChange}
                dropdownChangeFilter={dropdownChangeFilter}
                setDropDownChanged={setDropDownChanged}
                setDropDownChangedFilter={setDropDownChangedFilter}
                selectedValue={selectedValue}
                setSelectedValue={setSelectedValue}
                setIsDocViewVisible={setIsDocViewVisible}
                tempCustomizedColState={tempCustomizedColState}
                setTempCustomizedColState={setTempCustomizedColState}
                tempCustomizedFilterState={tempCustomizedFilterState}
                setTempCustomizedFilterState={setTempCustomizedFilterState}
                tempDefaultColState={tempDefaultColState}
                setTempDefaultColState={setTempDefaultColState}
                tempDefaultFilterState={tempDefaultFilterState}
                setTempDefaultFilterState={setTempDefaultFilterState}
                isLoading={isLoading}
                currentMode={currentMode}
                setCurrentMode={setCurrentMode}
                fileCount={fileCount}
                setFileCount={setFileCount}
                isFilterHappend={isFilterHappend}
                setIsFilterHappend={setIsFilterHappend}
                agGridListCount={agGridListCount}
                setAgGridListCount={setAgGridListCount}
                getAgResultCount={getAgResultCount}
                isCustomizedChanged={isCustomizedChanged}
                isDefaultChanged={isDefaultChanged}
                isGridReset={isGridReset}
                setIsGridReset={setIsGridReset}
                agFilterValue={agFilterValue}
                setAgFilterValue={setAgFilterValue}
                onDropDownValuesChange={onDropDownValuesChange}
                closeMenu={closeMenu}
                setFilterBadge={setFilterBadge}
                setGridContainerRef={setGridContainerRef}
                captureAppliedFilter={captureAppliedFilter}
                setExtraFilters={setExtraFilters}
                allArtifactList={allArtifactList}
                setIsBadgeRemoved={setIsBadgeRemoved}
                isBadgeRemoved={isBadgeRemoved}
              />
            </>
          )}
        </div>
      )}
    </>
  );
};

export default DocumentsSection;
